<template>
  <div>
    <v-toolbar dark height="35px" color="#00538b" class="pt-1">
      <v-col class="text-right">
        <v-btn color="#00538b" class="pr-4 elevation-0">
          <b-icon-envelope class="mr-2 mt-1"></b-icon-envelope>
          <v-toolbar-title
            ><a
              href="mailto:vcgs@vcgs.org.au"
              style="color: white; text-decoration: none;"
              >vcgs@vcgs.org.au</a
            ></v-toolbar-title
          >
        </v-btn>
        <v-btn color="#00538b" class="pr-4 elevation-0">
          <b-icon-telephone class="mr-2"></b-icon-telephone>
          <v-toolbar-title>
            <a
              href="tel:+611300118247"
              style="color: white; text-decoration: none"
              >1300 118 247</a
            ></v-toolbar-title
          >
        </v-btn>
      </v-col>
    </v-toolbar>

    <v-app-bar
      clipped-right
      color="grey flat lighten-4"
      extended
      extension-height="12"
      class="mb-4"
      style="border-top: 5px solid #00538b !important; background-color: #f7f7f7 !important;"
    >
      <v-row>
        <v-col class="custom-col">
          <v-toolbar-title>
            <v-img
              class="mr-auto"
              contain
              src="../assets/vcgs_logo.svg"
              alt="VCGS Logo"
              width="150px"
            />
          </v-toolbar-title>
        </v-col>
      </v-row>

      <v-toolbar-title class="header-text">
        Online test request system
      </v-toolbar-title>

      <div v-if="!$dataset.isProductionLike">
        <v-toolbar-title v-if="$dataset.isFrontEndOnly">
          <span class="ml-2 caption orange white--text"
            >THIS IS A FRONTEND ONLY</span
          >
        </v-toolbar-title>
        <v-toolbar-title v-else>
          <span class="ml-2 caption red white--text"
            >THIS IS NOT A PRODUCTION SITE</span
          >
        </v-toolbar-title>
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>
<script>
import { BIconTelephone, BIconEnvelope } from "bootstrap-vue";

export default {
  components: {
    BIconTelephone,
    BIconEnvelope,
  },
};
</script>

<style scoped>
.header-text {
  font-family: "Avenir", sans-serif !important;
  font-size: 30px !important;
}
</style>
